// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_jf-6";
export var emphasizeQuantity = "_jf-3";
export var flatBottomCorners = "_jf-5";
export var productImage = "_jf-0";
export var quantityContainer = "_jf-2";
export var tooltip = "_jf-1";
export var wrapAndEllipsesOverflow = "_jf-4";